import { useNavigate } from "react-router-dom";
import { Modal } from "react-bootstrap";
import { Context } from "../context/AppContext";
import { useContext, useState } from "react";

// ⚠️ IMPORTANT: Change "michelin-award.png" to your actual image filename
// and ensure it is in your src/assets/images folder.
import michelinImg from "../assets/images/michelin-2025.png.png"; 

const MichelinSection = () => {
  const navigate = useNavigate();
  const [modal, showModal] = useState(false);
  const { setRestaurantId } = useContext(Context);

  const handleOpenModal = () => showModal(true);

  const handleToOrder = (id) => {
    setRestaurantId(id);
    navigate("/online-order");
  };

  // Official Michelin Red for text accents
  const michelinRed = "#BD2333";
  // Your Brand Color for buttons/borders
  const brandColor = "#9d2a00";

  return (
    <section className="content-inner py-5" style={{ backgroundColor: "#fff" }}>
      <div className="container">
        
        {/* ─── Header ─── */}
        <div className="row justify-content-center text-center mb-5">
          <div className="col-lg-8">
            <h5 
              className="fw-bold text-uppercase mb-2" 
              style={{ color: michelinRed, letterSpacing: "2px" }}
            >
              2025 Selection
            </h5>
            <h2 className="display-4 fw-bold text-dark mb-3">
              THE MICHELIN GUIDE
            </h2>
            <div 
              style={{ 
                height: "4px", 
                width: "80px", 
                backgroundColor: michelinRed, 
                margin: "0 auto 20px" 
              }} 
            />
          </div>
        </div>

        <div className="row align-items-center">
          {/* ─── Left: Text Content ─── */}
          <div className="col-lg-6 mb-4 mb-lg-0">
            <div className="pe-lg-4">
              <h3 className="mb-3 fw-bold" style={{ color: "#2c2c2c" }}>
                "Taken the city by storm..."
              </h3>
              
              <p className="text-primary" style={{ fontSize: "1.1rem", lineHeight: "1.8" }}>
                The Guide describes us as <strong>"ground zero for fiery, tongue-numbing, chili-laden Sichuan cuisine."</strong>
              </p>
              
              <p className="text-primary" style={{ fontSize: "1.1rem", lineHeight: "1.8" }}>
                Alongside a number of offshoots around town, the original location opened in 2023 in an unsuspecting Cordova strip center. For those who love heat and savor spice, this is the place to be.
              </p>

              {/* Inspector's Recommendations */}
              <div className="mt-4 p-4 rounded-4" style={{ backgroundColor: "#fff5f2", borderLeft: `5px solid ${brandColor}` }}>
                <h6 className="fw-bold mb-3 text-uppercase" style={{ color: brandColor }}>
                  Inspector Favorites
                </h6>
                <ul className="list-unstyled mb-0 d-flex flex-wrap gap-2">
                  {[
                    "Mapo Tofu", 
                    "Stir-fried Cumin Lamb", 
                    "Crispy Chicken w/ Dried Chilis", 
                    "Charred Green Beans"
                  ].map((item, i) => (
                    <span key={i} className="badge bg-white text-dark shadow-sm fw-normal py-2 px-3 border">
                      {item}
                    </span>
                  ))}
                </ul>
              </div>

              <div className="mt-4">
                <button
                  onClick={handleOpenModal}
                  className="btn btn-lg fw-bold px-5 text-white shadow-sm"
                  style={{ 
                    backgroundColor: brandColor, 
                    borderRadius: "50px",
                    fontSize: "1.1rem"
                  }}
                >
                  Taste the Menu
                </button>
              </div>
            </div>
          </div>

          {/* ─── Right: Your Image ─── */}
          <div className="col-lg-6 text-center">
            <img 
              src={michelinImg} 
              alt="Michelin Guide Selection 2025" 
              className="img-fluid rounded-4 shadow-lg"
              style={{ 
                maxHeight: "500px", 
                objectFit: "cover",
                border: "1px solid rgba(0,0,0,0.1)" 
              }} 
            />
            <p className="text-muted mt-3 small fst-italic">
              "Portions are generous so bring friends and order with abandon."
            </p>
          </div>
        </div>
      </div>

      {/* ─────────────────────────────────────────────── */}
      {/* ─── ORIGINAL LOCATION MODAL (Restored) ─── */}
      {/* ─────────────────────────────────────────────── */}
      <Modal
        show={modal}
        onHide={() => showModal(false)}
        centered
        size="lg"
        backdrop="static"
      >
        <Modal.Header
          closeButton
          className="border-0"
          style={{
            backgroundColor: "#fff9f7",
            borderBottom: "1px solid rgba(157,42,0,0.15)",
          }}
        >
          <Modal.Title className="fw-bold text-dark">
            Choose a Location
          </Modal.Title>
        </Modal.Header>

        <Modal.Body
          className="bg-white text-dark"
          style={{
            borderRadius: "0 0 1rem 1rem",
          }}
        >
          <div className="container py-3">
            <div className="row gy-4 justify-content-center">
              {[
                {
                  id: 7,
                  title: "Cordova Location",
                  address: "1250 N Germantown Pkwy Cordova, TN 38016",
                  phone: "(901)-707-8886",
                },
                {
                  id: 11,
                  title: "Overton Square Location",
                  address: "2110 Madison Ave Memphis, TN 38104",
                  phone: "(901)-207-6680",
                },
                {
                  id: 40,
                  title: "小富贵 Little Petals Chinese (Downtown)",
                  address: "149 Madison Ave Memphis, TN 38103",
                  phone: "(901)-628-0086",
                },
                {
                  id: 73,
                  title: "小富贵 Little Petals Chinese 2 (Poplar)",
                  address: "5167 Poplar Ave Memphis, TN 38117",
                  phone: "(901)-668-9388",
                },
              ].map((loc, index) => (
                <div key={index} className="col-12 col-md-6 col-lg-5">
                  <div
                    className="border rounded-4 shadow-sm h-100 p-4 text-center"
                    style={{
                      borderColor: "rgba(157,42,0,0.15)",
                      transition: "all 0.3s ease",
                      background: "#fff",
                    }}
                  >
                    <h5 className="fw-bold mb-3 text-dark">{loc.title}</h5>
                    <p className="mb-1">{loc.address}</p>
                    <a
                      href={`tel:${loc.phone.replace(/[^0-9]/g, "")}`}
                      className="d-block mb-3 text-decoration-none text-muted fw-semibold"
                    >
                      {loc.phone}
                    </a>
                    <button
                      onClick={() => handleToOrder(loc.id)}
                      className="btn fw-semibold w-100"
                      style={{
                        backgroundColor: "#9d2a00",
                        color: "#fff",
                        borderRadius: 12,
                        transition: "background-color 0.2s ease",
                      }}
                      onMouseEnter={(e) =>
                        (e.target.style.backgroundColor = "#b83500")
                      }
                      onMouseLeave={(e) =>
                        (e.target.style.backgroundColor = "#9d2a00")
                      }
                    >
                      Order Here
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </section>
  );
};

export default MichelinSection;
